/**
 * Vue mixin for accessing indexedDb.
 * @author cm359n
 */

const DB_NAME = 'timetable'
const OBJECT_STORE_NAME = 'uofglife'
const DB_VERSION = 1

export default {
  methods: {
    async getFieldsFromIdb (guid, names) {
      let ret = {}
      if (this.idbSupported()) {
        let gi = await this.getGuidInfo(guid)
        for (const name of names) {
          if (typeof gi !== 'undefined' && name in gi) {
            ret[name] = gi[name]
          } else {
            console.error(name + ' field not available in guid info')
          }
        }
      } else {
        console.error('indexedd  is not supported - cannot get fields')
      }
      return ret
    },
    // drop-in replacement for $cookies.get('blah')
    async idbget (cookiestore, cookieName) {
      if (this.idbSupported()) {
        let guid = cookiestore.get('guid')
        if (typeof guid !== 'undefined') {
          let guidinfo = await this.getGuidInfo(guid)
          return guidinfo[cookieName]
        }
      } else {
        console.log('IndexedDB is not supported')
      }
    },
    async idbset (cookiestore, cookieName, cookieValue) {
      if (this.idbSupported()) {
        let guid = cookiestore.get('guid')
        if (typeof guid !== 'undefined') {
          await this.storeDb({
            'guid': guid,
            cookieName: cookieValue
          }, true) // mix this value in with what's already there
        }
      } else {
        console.log('IndexedDB is not supported')
      }
    },
    idbSupported () {
      return window.indexedDB
    },
    async getGuidInfo (guid) {
      console.log('getGuidInfo called')
      let txn = await this.setupTxn(
        'readonly',
        function () {
          console.log('got info for ' + guid)
        }
      )

      return new Promise((resolve, reject) => {
        let objStore = txn.objectStore(OBJECT_STORE_NAME)
        let request = objStore.get(guid)
        request.onsuccess = function (event) {
          resolve(event.target.result)
        }
        request.onerror = function () {
          reject(Error('no data found for guid ' + guid))
        }
      })
    },
    async deleteFor (guid) {
      console.log('deleteFor ' + guid + ' called')
      let txn = await this.setupTxn(
        'readwrite',
        function () {
          console.log('got info for ' + guid)
        }
      )

      return new Promise((resolve) => {
        let objStore = txn.objectStore(OBJECT_STORE_NAME)
        let request = objStore.delete(guid)
        request.onsuccess = function () {
          resolve()
        }
        request.onerror = function () {
          console.log('no data found for guid')
          resolve()
        }
      })
    },
    async storeDb (data, mixData) {
      let txn = await this.setupTxn(
        'readwrite',
        function () {
          console.log('saved guid to device')
        })
      let objStore = txn.objectStore(OBJECT_STORE_NAME)

      // avoid 'key already exists in the object store' errors by checking first :-)
      // let updated = false
      const guid = data['guid']
      let request = objStore.get(guid)
      request.onsuccess = function (event) {
        // update it
        let oldData = event.target.result
        // change it
        if (mixData) {
          for (let x in data) {
            // copy in values from data without replacing what's already in oldData
            if (typeof oldData === 'undefined') {
              oldData = {}
            }
            oldData[x] = data[x]
          }
        } else {
          // completely replace what's in oldData with data
          oldData = data
        }
        request = objStore.put(oldData)
        request.onsuccess = function () {
          console.log('data for ' + guid + ' was updated')
        }
        request.onerror = function (event) {
          console.log('update failed: ' + event.target.error)
        }
      }
      request.onerror = function (event) {
        // not in the db so try writing it
        console.log('error: ' + event.target.error)
        request = objStore.add(data)
        request.onsuccess = function () {
          console.log('finished saving guid')
        }
        request.onerror = function (event) {
          console.log("couldn't save guid: " + event.target.error)
        }
      }
    },
    async setupTxn (mode, successCallback, failureCallback) {
      let db = await this.getDb()
      let txn = db.transaction([OBJECT_STORE_NAME], mode)

      txn.oncomplete = successCallback
      if (typeof failureCallback !== 'undefined') {
        txn.onerror = failureCallback
      } else {
        // default behaviour - spit out the error on the console
        txn.onerror = function (event) {
          console.log('transaction failed: ' + event.target.error)
        }
      }
      return txn
    },
    async getDb () {
      return new Promise((resolve, reject) => {
        let request = window.indexedDB.open(DB_NAME, DB_VERSION)

        request.onerror = e => {
          console.log('Error opening db', e)
          reject(new Error("couldn't open indexedDb."))
        }

        request.onsuccess = e => {
          resolve(e.target.result)
        }

        request.onupgradeneeded = e => {
          console.log('onupgradeneeded')
          let db = e.target.result
          db.createObjectStore(OBJECT_STORE_NAME, { autoIncrement: true, keyPath: 'guid' })
        }
      })
    }

  }
}
